import { useSelector } from "react-redux";

import { getCurrentPromotionHook, useRbacPrimaryRolePermissions } from "../../api/hooks";

import { getUserEmail } from "../../selectors/app";

import { useFeatureFlagQuery } from "../useFeatureFlag";

export const useAiPromotion = () => {
	const { value: ffAiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: ffCurrentPromotionId } = useFeatureFlagQuery("ff-current-promotion", null);

	const { data: promotionData } = getCurrentPromotionHook(ffCurrentPromotionId || "", !!ffCurrentPromotionId);

	const { data: aiPermissions } = useRbacPrimaryRolePermissions("ai");
	const canViewPromotion = aiPermissions?.includes("ai:viewPromotion") ?? false;

	const userEmail = useSelector(getUserEmail);

	const isAiPromotion = !ffAiEnabled && promotionData?.type === "ai" && canViewPromotion;

	return { isAiPromotion, promotionId: ffCurrentPromotionId || "", userEmail: userEmail || "" };
};
